import { render, staticRenderFns } from "./ButtonTag.vue?vue&type=template&id=a9a99bc4&"
import script from "./ButtonTag.vue?vue&type=script&lang=js&"
export * from "./ButtonTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports